import { useCurrency } from '@shared/selectors/globalSelectors';
import React from 'react';

export default function SlabBased({ slabs, variant = 'bars' }: { slabs: any[], variant?: 'bars' | 'table' }) {
    const currency=useCurrency();
  if (variant === 'table') {
    return (
      <div className="rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-50 text-xs font-bold text-slate-500">
            <tr>
              <th className="px-6 py-4 tracking-wider">Range</th>
              <th className="px-6 py-4 tracking-wider">Type</th>
              <th className="px-6 py-4 text-right tracking-wider">Rate</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white">
            {slabs.map((slab: any, index: number) => {
              const range = `${slab.from}—${!slab.to || slab.to === 0 ? '∞' : slab.to}`;
              const typeLabel = slab.mode ? slab.mode.charAt(0).toUpperCase() + slab.mode.slice(1) : 'Variable';
              
              return (
                <tr key={index}>
                  <td className="px-6 py-4 font-semibold text-slate-800">{range}</td>
                  <td className="px-6 py-4">
                    <span className="inline-flex justify-center rounded-full border border-cyan-200 bg-cyan-50 px-3 py-1 text-xs font-semibold text-cyan-700">
                      {typeLabel}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right font-bold text-slate-800">
                    {currency} {slab.rate} <span className="font-semibold text-slate-400 ml-1">{slab.unit}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const maxRate = Math.max(...slabs.map((s: any) => s.rate || 0), 1);
  return (
    <div className="space-y-4">
      {slabs.map((slab: any, index: number) => {
        const range = `${slab.from ?? slab.startTime ?? 'NA'} — ${slab.to ?? slab.endTime ?? 'NA'}`;
        const barWidth = `${((slab.rate || 0) / maxRate) * 100}%`;
        const typeLabel = slab.mode ? slab.mode.charAt(0).toUpperCase() + slab.mode.slice(1) : 'NA';
        
        return (
          <div key={index} className="flex items-center gap-4 sm:gap-6">
            <div className="w-24 sm:w-32 shrink-0 text-sm font-medium text-slate-600 break-all">
              {range ?? 'NA'}
            </div>
            <div className="shrink-0 w-20">
              <span className="inline-flex w-full justify-center rounded-full border border-cyan-200 bg-cyan-50 px-3 py-1 text-xs font-semibold text-cyan-700">
                {typeLabel}
              </span>
            </div>
            <div className="relative h-10 flex-1 overflow-hidden rounded-md bg-slate-50">
              <div 
                className="absolute inset-y-0 left-0 flex items-center rounded-md bg-[#1d64c9] px-4 text-sm font-semibold text-white transition-all duration-500"
                style={{ width: barWidth, minWidth: 'fit-content' }}
              >
                {currency} {slab.rate} {slab.unit}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}